
import { Component,OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HandholeService } from '../../../../../shared/services/fiber-management/handhole.service.mjs';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-handhole-create',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputSwitchModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
    ButtonModule
  ],
  templateUrl: './handhole-create.component.html',
  styleUrls: ['./handhole-create.component.scss'],
})
export class HandholeCreateComponent implements OnInit {
  @Input() displayTaskModal: boolean = false;
  @Input() order: Order | null = null;
  @Output() closeTaskModal = new EventEmitter<void>();
  handholeForm!: FormGroup;
  isLoading = false;
  taskForm = new FormGroup({
    serviceName: new FormControl(''),
    clientName: new FormControl('Kathryn Murphy'),
    dueDate: new FormControl(new Date()),
    status: new FormControl('Paid'),
    items: new FormControl(2),
    total: new FormControl('$0'),
    orderId: new FormControl('#0145'),
  });
  clientPhoto = 'https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'; // Replace with actual image URL

  statusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ];

  itemOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
  ];

  saveChanges() {
    console.log('Saving:', this.order);
    this.closeTaskModal.emit();
  }
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private handholeService: HandholeService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.handholeForm = this.fb.group({
      size: ['', Validators.required],
      status: ['', Validators.required],
      coordinates: ['', Validators.required],
      is_4x4: [false, Validators.required],
      is_vdot: [false, Validators.required],
    });
  }

  onSubmit(): void {
    if (this.handholeForm.valid) {
      const newHandhole = this.handholeForm.value;
      this.isLoading = true;

      this.handholeService.insert(newHandhole)
        .then(() => {
          console.log('Handhole created successfully');
          this.router.navigate(['/handhole/list']);
        })
        .catch((error) => {
          console.error('Error creating handhole:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
